import { useAuth } from "../auth/AuthContext";
import { useTenant } from "../context/TenantContext";
import { getUserTenantId } from "../utils/getUserTenantId";
import { getTenantUserId } from "../utils/getTenantUserId";

export function useResolvedTenantId() {
  const { user } = useAuth();
  const { tenantId: selectedTenantId, tenantName } = useTenant();

  const tenantId = selectedTenantId || getUserTenantId(user);
  const tenantUserId = getTenantUserId(user, tenantId);

  return {
    user,
    tenantId,
    tenantUserId,
    tenantName,
  };
}